function timeSince(date, nowDate=null) {
  var now = nowDate ? nowDate :  Math.floor(new Date().getTime() / 1000);
  var seconds = Math.abs(now - date);
  var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    return `${interval} ${interval > 1 ? 'years' : 'year'}`;
  }
  interval = Math.floor(seconds / 2592000);
  if (interval >= 1) {
    return `${interval} ${interval > 1 ? 'months' : 'month'}`;;
  }
  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    return `${interval} ${interval > 1 ? 'days' : 'day'}`;;
  }
  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    return `${interval} ${interval > 1 ? 'hours' : 'hour'}`;;
  }
  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return `${interval} ${interval > 1 ? 'minutes' : 'minute'}`;;
  }
  return Math.floor(seconds) + " seconds";
}

export default timeSince;
